import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Check, ContentCopy } from '@mui/icons-material';

interface CopyButtonProps {
    textToCopy: string;
    size?: 'small' | 'medium' | 'large';
    tooltipTitle?: string;
}

export const CopyButton: React.FC<CopyButtonProps> = ({
    textToCopy,
    size = 'medium',
    tooltipTitle = 'Copy to clipboard',
}) => {
    const [copySuccess, setCopySuccess] = useState(false);

    const handleCopy = async (): Promise<void> => {
        try {
            await navigator.clipboard.writeText(textToCopy);
            setCopySuccess(true);
            setTimeout(() => setCopySuccess(false), 2000);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    const iconSize = size !== 'large' ? 'small' : 'medium';
    const buttonSize = size;

    return (
        <Tooltip title={copySuccess ? 'Copied!' : tooltipTitle}>
            <IconButton
                size={buttonSize}
                sx={{
                    padding: size === 'small' ? 0.5 : undefined,
                    color: copySuccess ? 'success.main' : undefined,
                    ...(size === 'small' && {
                        width: 16,
                        height: 16,
                        '& .MuiSvgIcon-fontSizeSmall': {
                            fontSize: '0.875rem',
                        },
                    }),
                }}
                onClick={handleCopy}
            >
                {copySuccess ? (
                    <Check fontSize={iconSize} />
                ) : (
                    <ContentCopy fontSize={iconSize} />
                )}
            </IconButton>
        </Tooltip>
    );
};
